// vendor modules
import React, { Component } from "react"
import PropTypes from "prop-types"

import { SearchBar } from "quorumdesign"

class TextInputFilter extends Component {
    static propTypes = {
        advancedSearch: PropTypes.bool,
        fullBar: PropTypes.bool,
        displayLabel: PropTypes.string,
        errorMessage: PropTypes.string,
        keyboardType: PropTypes.string,
        helpText: PropTypes.string,
        placeholderText: PropTypes.string,
        myId: PropTypes.string,
        shouldValidateInput: PropTypes.bool,
        validateTextInput: PropTypes.func,
    }

    constructor(props) {
        super(props)

        this.listenForEnter = this.listenForEnter.bind(this)
        this.changeInputValue = this.changeInputValue.bind(this)
        this.changeValue = this.changeValue.bind(this)
        this.submitText = this.submitText.bind(this)
        this.clearValue = this.clearValue.bind(this)

        this.state = {
            inputText: this.props.value || "",
            displayError: false,
        }
    }

    componentDidUpdate(oldProps) {
        if (this.props.value == null && oldProps.value != null && this.state.inputText) {
            // checks to see if filter was forcibly set to undefined, then
            // clear the value
            this.setState({ inputText: "" })
        }

        if (this.props.value != null && oldProps.value == null && !this.state.inputText) {
            // if the value is changed externally (from URL or default filter)
            // then setState to the new value
            this.setState({ inputText: this.props.value })
        }
    }

    listenForEnter(e) {
        if (e.key === "Enter" || this.props.shouldSubmitOnChange) {
            return this.submitText()
        }
    }

    changeInputValue(e) {
        this.setState({ inputText: e.target.value })

        // in the case somebody clears the text in the text box,
        // clear the filter!
        if (!e.target.value) {
            this.props.publishChange(undefined)
        }
    }

    changeValue(value) {
        this.setState({ inputText: value })

        if (!value) {
            this.props.publishChange(undefined)
        }
    }

    submitText() {
        if (
            this.state.inputText &&
            this.props.shouldValidateInput &&
            !this.props.validateTextInput(this.state.inputText)
        ) {
            this.setState({ displayError: true })
            return
        }

        this.props.publishChange(this.state.inputText)
        this.setState({ displayError: false })
    }

    clearValue() {
        this.setState({ inputText: "" }, () => this.submitText())
    }

    render() {
        return (
            <div className="filter-container">
                <SearchBar
                    clearOnClick={this.clearValue}
                    disableDebounce
                    fullWidth
                    isFilter
                    onChange={this.changeValue}
                    onKeyUp={this.listenForEnter}
                    onSearch={this.submitText}
                    placeholder={this.props.placeholderText}
                    value={this.state.inputText}
                />
                {this.state.displayError && <div className="error-message">{this.props.errorMessage}</div>}
            </div>
        )
    }
}

export default TextInputFilter
